<template>
  <div>
    <div style="margin: 0 315px" class="px-6 py-7 mt-10 border-gray-400 bra-6" v-if="step === 4 ">
      <h2 class="font-16 font-weight-medium" style="color: #0D0D0E">Revisar e aplicar</h2>
      <p>Revise antes de aplicar. Esta configuração vai influenciar as sugestões de compra nos períodos de compra
        definidos nas rodadas.</p>

      <div style="padding: 50px 150px 100px">
        <div>
          <h3 class="font-12" style="color: #73787F;">Escopo</h3>
          <p class="font-15 font-weight-medium" style="color: #39404B">{{ escopo }} item(s)</p>
        </div>

        <div class="mt-5">
          <h3 class="font-12" style="color: #73787F;">Rodadas de Compras</h3>
          <ul>
            <li
              class="font-15 font-weight-medium"
              style="color: #39404B"
              v-for="(rodada, index) in rodada_compra"
            >
              <span :key="index">
                {{ rodada.nome }}: comprar em
                {{ formatarDataBRCondicional(rodada.data_inicio_aplicacao) }} - {{ formatarDataBRCondicional(rodada.data_fim_aplicacao) }}, com base nas vendas de
                {{ formatarDataBRCondicional(rodada.data_inicio_referencia) }} - {{ formatarDataBRCondicional(rodada.data_fim_referencia) }}
              </span>
            </li>
          </ul>
        </div>

        <div class="mt-5">
          <h3 class="font-12" style="color: #73787F;">Influência</h3>
          <ul>
            <li class="font-15 font-weight-medium" style="color: #39404B">Geral: {{ resumo_ajustes.representatividade_escopo }}%</li>
            <li class="font-15 font-weight-medium" style="color: #39404B">Ajustes por item: {{ resumo_ajustes.itens_ajustados }} itens (representatividade {{ resumo_ajustes.representatividade_escopo }}% | impacto adicional {{ resumo_ajustes.impacto_adicional_ajuste }}%)</li>
            <li class="font-15 font-weight-medium" style="color: #39404B">Total estimada: {{ resumo_ajustes.influencia_total_estimada }}%</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  step: {
    type: Number,
    required: true
  },
  escopo: {
    type: Number,
    default: 0
  },
  rodada_compra: {
    type: Array,
    required: false,
    default: []
  },
  resumo_ajustes: {
    type: Object,
    required: false,
    default: {}
  },
});

function formatarDataBRCondicional(v) {
  if (typeof v !== 'string') return v

  const m = v.match(/^(\d{4})-(\d{2})-(\d{2})$/)
  if (!m) return v

  const [, yyyy, mm, dd] = m
  return `${dd}/${mm}/${yyyy}`
}
</script>

<style scoped>

</style>
